import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { LoadingGif, LoadingMessage } from './CommonStyles';

interface AdminRouteProps {
	children: JSX.Element;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
	const { user, isLoading } = useAuth();
	const location = useLocation();

	if (isLoading) {
		return (
			<LoadingMessage>
				<LoadingGif size="large" />
			</LoadingMessage>
		);
	}

	if (!user) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	if (!user.roles.includes('Admin')) {
		// Redirect to home page or an unauthorized page if not an admin
		return <Navigate to="/" replace />;
	}

	return children;
};

export default AdminRoute;
